import { EventTypes, track, trackGoldStandardEvent } from '@mc/track-event'

export const trackRelatedContentCarouselTileClick = (slug: string) => {
  track(EventTypes.EPISODE_PAGE_CLICK, {
    category: 'explore-class-catalog',
    location: 'members_also_liked',
    action: 'click',
    class: slug,
  })
}
export const trackRelatedContentCarouselViewed = () => {
  trackGoldStandardEvent(EventTypes.EPISODE_PAGE_ROW_VIEWED, {
    category: 'explore-class-catalog',
    row_name: 'members_also_liked',
  })
}
